import {Pipe, PipeTransform} from '@angular/core';
import {DateUtilities} from '@shared/utilities/date-utilities.model';

@Pipe({
	name: 'dateInterval'
})
export class DateIntervalPipe implements PipeTransform {

	transform(value: any[], format: DateIntervalFormat = DateIntervalFormat.ALL): string {
		if (!!value) {
			const date_interval: { days: number, hours: number, minutes: number, seconds: number } = DateUtilities.getDifferenceBetweenToDate(value[0], value[1]);
			switch (format) {
				case DateIntervalFormat.ALL:
					return `${date_interval.days} gg ${date_interval.hours} hh ${date_interval.minutes} min ${date_interval.seconds} sec`;
				case DateIntervalFormat.DD_HH_MM:
					return `${date_interval.days} gg ${date_interval.hours} hh ${date_interval.minutes} min`;
				case DateIntervalFormat.DD_HH:
					return `${date_interval.days} gg ${date_interval.hours} hh`;
				case DateIntervalFormat.DD:
					return `${date_interval.days} gg`;
			}
		} else {
			return null;
		}
	}

}

export enum DateIntervalFormat {
	ALL,
	DD,
	DD_HH,
	DD_HH_MM
}
